export default __webpack_public_path__ + "static/media/homeLogo.6cd602cb.jpg";